export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11228.44519549.jpg";